import { FunctionComponent } from 'react';
import SignatureRequestViewer from '../../components/SignatureRequestViewer/SignatureRequestViewer';

export const SignatureRequestsViewPage: FunctionComponent = () => {
  return <SignatureRequestViewer pdf="/29cbd16b-c1c6-4db0-9417-b0117ddbb8cb.pdf" />;
};
